<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1> {{ $t('prices') }} / {{ user.fullname }} </h1>
        <h4>{{ service.carrier.name }} / {{ service.name }}</h4>

        <v-btn color="primary" @click="pickFile"> {{ $t('importExcel') }} </v-btn>
        <input type="file" style="display: none" ref="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="onFilePicked">
        <v-btn text color="primary" link href="https://hydraship-co-demo.s3.us-west-2.amazonaws.com/service-prices.xlsx" target="_blank"> {{ $t('downloadExample') }} </v-btn>
      </v-flex>

      <v-flex xs12>
        <v-card class="mt-4">
          <v-card-text>
            <v-data-table class=""
                          :headers="headers"
                          :items="prices"
                          :loading="loading"
                          hide-actions
                          :no-data-text="$t('noDataAvailable')">
              <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td> {{ props.item.kg }} </td>
                <td> {{ props.item.price | currency }} </td>
                <td class="pa-0 pr-2 text-xs-right">
                  <v-btn color="primary" flat icon @click="editUserPrice(props.item)">
                    <font-awesome-icon icon="edit"></font-awesome-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="back">{{ $t('back') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="userPrice.price" :label="$t('attrs.price')"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="cancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" dark @click="save">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import XLSX from 'xlsx'

import User from '@/client/user'
import Service from '@/client/service'
import ServicePrice from '@/client/service-price'
import UserPrice from '@/client/user-price'

export default {
  name: 'UserPriceFormView',

  props: {},

  data () {
    return {
      headers: [
        { text: 'KG', align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.price'), align: 'left', sortable: true, value: 'provider.name' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      loading: false,
      dialog: false,

      user: {},
      service: {
        carrier: {}
      },
      servicePrices: [],
      userPrices: [],
      userPrice: {},
      prices: []
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      UserPrice.userId = this.user.id
      this.userPrices = await UserPrice.all({
        where: {
          service_id: this.service.id
        },
        order: 'kg asc'
      })

      this.preparePrices()
      this.loading = false
    },

    preparePrices () {
      this.prices = []
      this.servicePrices.forEach(price => {
        const userPrice = this.userPrices.find(o => o.kg === price.kg) || {}
        this.prices.push({
          user_id: this.$route.params.userId,
          service_id: this.$route.params.serviceId,
          kg: price.kg,
          price: userPrice.price || price.price,
          error: ''
        })
      })
    },

    async save () {
      try {
        const userPrice = new UserPrice(this.userPrice)
        await userPrice.save()
      } catch (err) {
        // empty
      }
      this.dialog = false
      this.fetch()
    },

    cancel () {
      this.dialog = false
      this.preparePrices()
    },

    editUserPrice (userPrice) {
      this.userPrice = userPrice
      this.dialog = true
    },

    pickFile () {
      this.$refs.file.click()
    },

    onFilePicked (e) {
      const file = e.target.files[0]
      const self = this

      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const wb = XLSX.read(data, { type: 'binary' })
        wb.SheetNames.forEach(sn => {
          let res = XLSX.utils.sheet_to_json(wb.Sheets[sn])
          const prices = res.map(row => {
            let userPrice = self.userPrices.find(o => o.kg === row.kg)
            if (userPrice) {
              userPrice.price = row.price
            } else {
              userPrice = new UserPrice({
                user_id: self.$route.params.userId,
                service_id: self.$route.params.serviceId,
                kg: row.kg,
                price: row.price,
              })
            }
            return userPrice.save()
          })

          Promise.all(prices).then(() => self.fetch())
        })
      }

      reader.readAsBinaryString(file)
    },
  },

  watch: {
  },

  async mounted () {
    this.user = await User.findOne(this.$route.params.userId)
    this.service = await Service.findOne(this.$route.params.serviceId, {
      include: 'carrier'
    })
    this.servicePrices = await ServicePrice.all({
      where: {
        service_id: this.$route.params.serviceId
      },
      order: 'kg asc'
    })

    this.fetch()
  }
}
</script>
